import { render, staticRenderFns } from "./duplicate_request_sent.vue?vue&type=template&id=88c9f6c4&scoped=true"
import script from "./duplicate_request_sent.vue?vue&type=script&lang=js"
export * from "./duplicate_request_sent.vue?vue&type=script&lang=js"
import style0 from "./duplicate_request_sent.vue?vue&type=style&index=0&id=88c9f6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c9f6c4",
  null
  
)

export default component.exports